import { motion } from "framer-motion";

const ResumePage = () => {
  const resumeUrl = "/Mohamed Mafaz.pdf"; // Ensure the file is inside "public/"

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-black via-gray-900 to-black px-4"
    >
      {/* ✅ Header Section: "My Resume" + Download Button */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="flex items-center justify-between w-full max-w-4xl mb-6"
      >
        <h1 className="text-4xl font-bold text-white">My Resume</h1>

        {/* ✅ Custom Download Button */}
        <a
          href={resumeUrl}
          download="Mohamed Mafaz.pdf"
          className="relative inline-block text-lg group"
        >
          <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
            <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
            <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
            <span className="relative">Download Resume</span>
          </span>
          <span
            className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0"
            data-rounded="rounded-lg"
          ></span>
        </a>
      </motion.div>

      {/* ✅ Resume PDF Viewer */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="w-full max-w-6xl bg-gray-900 shadow-xl rounded-lg overflow-hidden p-6 border border-gray-700"
      >
        <iframe
          src={resumeUrl}
          className="w-full h-[750px] border-none rounded-md bg-gray-900"
          title="Resume"
        />
      </motion.div>
    </motion.div>
  );
};

export default ResumePage;